import {
  EConnectionStatus,
} from './rendering-engine-view.ts';

const connectionStatus: Record<EConnectionStatus, string> = {
  [EConnectionStatus.CONNECTING]: 'Złączony',
  [EConnectionStatus.CONNECTED]: 'Czekam na dane',
  [EConnectionStatus.WAITING_FOR_DATA]: 'Połączony',
  [EConnectionStatus.ERROR]: 'Błąd',
};

export default {
  connectionStatus,
  latestUpdate: 'Ostatnia aktualizacja',
  enterFullscreen: 'Pełny ekran',
  exitFullscreen: 'Wyjdź z trybu pełnoekranowego',
};
